import * as Html from "../../util/Html.ts";
import * as FwDatas from "../../FwDatas.ts"
import * as CustomInput from "../../util/CustomInput.ts"
export {initDom}
Html.registerWidget('widget/form/timetabledate-selection',{initDom})

function initDom(element: HTMLElement){
  const form = element.closest('form') as HTMLFormElement;
  if(!form) return;

  let timetable = FwDatas.get((form as any).calendarId.value);
  const startHiddenInput = form.startDate as HTMLInputElement;
  const endHiddenInput = form.endDate as HTMLInputElement;
  const weekSelect = form.startweek as HTMLSelectElement;
  const startSelectDay = form.startday as HTMLSelectElement;
  const startSelectHour = form.starttime as HTMLInputElement;
  const endSelectDay = form.endday as HTMLSelectElement;
  const endSelectHour = form.endtime as HTMLInputElement;
  let updateEndOnBeginChange = true;

  //if it is a CalendarBean and not a TimetableBean
  if(timetable.timetable){
    timetable = timetable.timetable
  }

  if(timetable.weeks.length>1){
    weekSelect.innerHTML = timetable.weeks.map(week=>`<option value=${week.index}>${week.name}</option>`).join('')
  }
  startSelectDay.innerHTML = timetable.weeks[0].days.map((day)=>`<option value=${day.index}>${day.name}</option>`).join('')
  endSelectDay.innerHTML = timetable.weeks[0].days.map((day)=>`<option value=${day.index}>${day.name}</option>`).join('')

  endSelectDay.addEventListener('change',function(){
    updateEndOnBeginChange = false;
  });
  endSelectHour.addEventListener('change',function(){
    updateEndOnBeginChange = false;
  });

  function updateUI(){
    const startDate = CustomInput.getDateValue(startHiddenInput);
    const endDate = CustomInput.getDateValue(endHiddenInput);
    if(!startDate || !endDate) return;

    weekSelect.value = String(timetable.getWeek(startDate).index);
    startSelectDay.value = String(startDate.getDay());
    CustomInput.setDateValue(startSelectHour, startDate);

    CustomInput.setDateValue(endSelectHour, endDate);
    endSelectDay.value = String(endDate.getDay());
  }
  updateUI()

  const inputs = form.querySelectorAll<HTMLInputElement>(':input');
  inputs.forEach(input => {
    input.addEventListener('blur', function(this: HTMLInputElement){
      const weekVal = weekSelect ? weekSelect.value || '0' : '0';
      const week = timetable.weeks[weekVal];
      const startday = week.days.find(day => day.index == startSelectDay.value);
      const startHour = startSelectHour.value;
      const endday = week.days.find(day => day.index == endSelectDay.value);
      const endHour = endSelectHour.value;
      let startFinal = new Date(startday.value+'T'+startHour);
      let endFinal = new Date(endday.value+'T'+endHour);

      if(this.name==='endday'||this.name==='endtime'){
        const currentEndDate = CustomInput.getDateValue(endHiddenInput);
        if(currentEndDate && endFinal.getTime()!==currentEndDate.getTime()){
          updateEndOnBeginChange = false;
        }
      }
      if(updateEndOnBeginChange && (this.name==='startday'||this.name==='starttime')){
        const currentStartDate = CustomInput.getDateValue(startHiddenInput);
        if(currentStartDate) {
          const delta = startFinal.getTime() - currentStartDate.getTime();
          endFinal.setTime(endFinal.getTime()+delta)
        }
      }
      if(endFinal<startFinal){
        endFinal.setDate(endFinal.getDate()+7);
      }
      CustomInput.setDateValue(startHiddenInput, startFinal);
      CustomInput.setDateValue(endHiddenInput, endFinal);

      updateUI()
    });
  });
}
